<template>
    <div class="boxes light purple">
        <div class="box">
          <h1>{{t("Weightings and Measurements")}}</h1>
          <div class="form-group" v-if="newWeightingEnabled">
              <p>{{t("It is time to enter a new weighting and measurement. Please enter your current weight and circumferences.")}}</p>
              <input type="text" class="form-control" id="weight" v-model="weight" :placeholder="t('Weight')">
              <input type="text" class="form-control" id="chest" v-model="chest" :placeholder="t('Chest')">
              <input type="text" class="form-control" id="waist" v-model="waist" :placeholder="t('Waist')">
              <input type="text" class="form-control" id="hips" v-model="hips" :placeholder="t('Hips')">
              <button class="btn btn-primary" @click="addWeighting">{{t("Add Weighting")}}</button>
          </div>
          <div v-else>
              <p>{{t("You can add a new weighting in {0} days", timeToNextWeighting)}}</p>
          </div>
        </div>

        <div>
          <h2>{{t("Weightings and measurement history")}}</h2>
          <div v-for="item in allWeightingsAndMeasurements" :key="item.day" class="box form-group">
            <h3>{{t("Day {0}", item.day)}}</h3>
            <p v-if="item.weight">{{t("Weight")}}: {{item.weight}}</p>
            <p v-if="item.chest">{{t("Chest")}}: {{item.chest}}</p>
            <p v-if="item.waist">{{t("Waist")}}: {{item.waist}}</p>
            <p v-if="item.hips">{{t("Hips")}}: {{item.hips}}</p>
          </div>
        </div>
    </div>
</template>

<script>

import t from "@/lib/Locale";
import Fito from "@/lib/fito";

export default {
  name: "WeightingsAndMeasurements",
  props: ['onChange','data'],
  data() {
      return {
        daysInPlan: 0,
        weightings: [],
        measurements: [],
        weight: '',
        chest: '',
        waist: '',
        hips: '',
      }
  },

  async mounted() {
    const login = await Fito().Login.safeCheckLogin()
    if (!login) return this.$router.push('/plan/login')

    this.daysInPlan = login.daysInPlan

    if (login.meta && login.meta['weightings']) {
      this.weightings = login.meta['weightings']
    }
    if (login.meta && login.meta['waist_measure']) {
      this.measurements = login.meta['waist_measure']
    }
  },

  computed : {
    newWeightingEnabled() {
      // if more than 2 weeks have passed since the last weighting
      if (this.weightings.length === 0) return true
      const lastWeighting = this.weightings[this.weightings.length - 1]
      return this.daysInPlan - lastWeighting.day > 14
    },

    timeToNextWeighting() {
      if (this.weightings.length === 0) return 0
      const lastWeighting = this.weightings[this.weightings.length - 1]
      console.log(lastWeighting)
      return 14 - (this.daysInPlan - lastWeighting.day)
    },

    joinedWeightingsAndMeasurements() {
      return this.weightings.map(w => {
        const m = this.measurements.find(meas => meas.day === w.day)
        return {
          day: w.day,
          weight: w.weight,
          chest: m ? m.chest : '',
          waist: m ? m.waist : '',
          hips: m ? m.hips : '',
        }
      })
    },

    unjoinedWeightings() {
      return this.weightings.filter(w => !this.measurements.find(m => m.day === w.day))
    },

    unjoinedMeasurements() {
      return this.measurements.filter(m => !this.weightings.find(w => w.day === m.day))
    },

    allWeightingsAndMeasurements() {
      let all = this.joinedWeightingsAndMeasurements.concat(this.unjoinedWeightings.map(w => {
        return {
          day: w.day,
          weight: w.weight,
          chest: '',
          waist: '',
          hips: '',
        }
      })).concat(this.unjoinedMeasurements.map(m => {
        return {
          day: m.day,
          weight: '',
          chest: m.chest,
          waist: m.waist,
          hips: m.hips,
        }
      })).sort((a, b) => a.day - b.day)

      // get the latest entry from each day
      let unique = {}
      all.forEach(it => {
        unique[it.day] = it
      })
      return Object.values(unique).reverse()
    },
  },

  methods: {
      t,
      addWeighting() {
        if (this.weight) {
          this.weightings.push({
            day: this.daysInPlan,
            weight: this.weight,
          })
          Fito().RunAction('submit-weighting', {day: this.daysInPlan, weight: this.weight})
          this.weight = ''
        }
        if (this.chest || this.waist || this.hips) {
          this.measurements.push({
            day: this.daysInPlan,
            chest: this.chest,
            waist: this.waist,
            hips: this.hips,
          })
          Fito().RunAction('submit-waist', {day: this.daysInPlan, chest: this.chest, waist: this.waist, hips: this.hips})
          this.chest = ''
          this.waist = ''
          this.hips = ''
        }
      },
    }
}

</script>